"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const createDynamicContextFunction_1 = require("./createDynamicContextFunction");
const findAttribute_1 = __importDefault(require("./findAttribute"));
const getComponentText_1 = __importDefault(require("./getComponentText"));
const componentAttributeProperties = [
    'component_type',
    'preselected_count',
    'total_objects_available',
    'total_objects_displayed',
    'user_selected_count',
];
const componentAttributeTypes = {
    component_type: 'string',
    preselected_count: 'integer',
    total_objects_available: 'integer',
    total_objects_displayed: 'integer',
    user_selected_count: 'float',
    label: 'string',
    element_id: 'string',
    element_key: 'string',
};
const generateComponentContext = (element) => {
    const label = (0, getComponentText_1.default)(element) !== null && (0, getComponentText_1.default)(element) !== undefined
        ? (0, getComponentText_1.default)(element)
        : '';
    const data = { label };
    const elementId = element.id;
    if (elementId !== null) {
        data.element_id = elementId;
    }
    const key = element.getAttribute('data-snowplow-component-key');
    if (key !== null) {
        data.element_key = key;
    }
    componentAttributeProperties.forEach((prop) => {
        const formattedProp = (0, createDynamicContextFunction_1.snakeToKebab)(prop);
        const attribute = (0, findAttribute_1.default)(element, `data-snowplow-${formattedProp}`);
        if (attribute !== null) {
            const propType = componentAttributeTypes[prop];
            const formattedAttribute = (0, createDynamicContextFunction_1.parseAttribute)(attribute, propType);
            data[prop] = formattedAttribute;
        }
    });
    return data;
};
exports.default = generateComponentContext;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2VuZXJhdGVDb21wb25lbnRDb250ZXh0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3V0aWxzL2R5bmFtaWNDb250ZXh0L2dlbmVyYXRlQ29tcG9uZW50Q29udGV4dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUNBLGlGQUE4RTtBQUU5RSxvRUFBNEM7QUFDNUMsMEVBQWtEO0FBRWxELE1BQU0sNEJBQTRCLEdBQXFDO0lBQ25FLGdCQUFnQjtJQUNoQixtQkFBbUI7SUFDbkIseUJBQXlCO0lBQ3pCLHlCQUF5QjtJQUN6QixxQkFBcUI7Q0FDeEIsQ0FBQztBQUVGLE1BQU0sdUJBQXVCLEdBQThDO0lBQ3ZFLGNBQWMsRUFBRSxRQUFRO0lBQ3hCLGlCQUFpQixFQUFFLFNBQVM7SUFDNUIsdUJBQXVCLEVBQUUsU0FBUztJQUNsQyx1QkFBdUIsRUFBRSxTQUFTO0lBQ2xDLG1CQUFtQixFQUFFLE9BQU87SUFDNUIsS0FBSyxFQUFFLFFBQVE7SUFDZixVQUFVLEVBQUUsUUFBUTtJQUNwQixXQUFXLEVBQUUsUUFBUTtDQUN4QixDQUFDO0FBRUYsTUFBTSx3QkFBd0IsR0FBRyxDQUFDLE9BQW9CLEVBQXVCLEVBQUU7SUFDM0UsTUFBTSxLQUFLLEdBQ1AsSUFBQSwwQkFBZ0IsRUFBQyxPQUFPLENBQUMsS0FBSyxJQUFJLElBQUksSUFBQSwwQkFBZ0IsRUFBQyxPQUFPLENBQUMsS0FBSyxTQUFTO1FBQ3pFLENBQUMsQ0FBQyxJQUFBLDBCQUFnQixFQUFDLE9BQU8sQ0FBQztRQUMzQixDQUFDLENBQUMsRUFBRSxDQUFDO0lBRWIsTUFBTSxJQUFJLEdBQXdCLEVBQUUsS0FBSyxFQUFFLENBQUM7SUFDNUMsTUFBTSxTQUFTLEdBQUcsT0FBTyxDQUFDLEVBQUUsQ0FBQztJQUU3QixJQUFJLFNBQVMsS0FBSyxJQUFJLEVBQUU7UUFDcEIsSUFBSSxDQUFDLFVBQVUsR0FBRyxTQUFTLENBQUM7S0FDL0I7SUFFRCxNQUFNLEdBQUcsR0FBRyxPQUFPLENBQUMsWUFBWSxDQUFDLDZCQUE2QixDQUFDLENBQUM7SUFFaEUsSUFBSSxHQUFHLEtBQUssSUFBSSxFQUFFO1FBQ2QsSUFBSSxDQUFDLFdBQVcsR0FBRyxHQUFHLENBQUM7S0FDMUI7SUFFRCw0QkFBNEIsQ0FBQyxPQUFPLENBQUMsQ0FBQyxJQUFJLEVBQUUsRUFBRTtRQUMxQyxNQUFNLGFBQWEsR0FBRyxJQUFBLDJDQUFZLEVBQUMsSUFBSSxDQUFDLENBQUM7UUFDekMsTUFBTSxTQUFTLEdBQUcsSUFBQSx1QkFBYSxFQUFDLE9BQU8sRUFBRSxpQkFBaUIsYUFBYSxFQUFFLENBQUMsQ0FBQztRQUMzRSxJQUFJLFNBQVMsS0FBSyxJQUFJLEVBQUU7WUFDcEIsTUFBTSxRQUFRLEdBQUcsdUJBQXVCLENBQUMsSUFBSSxDQUFDLENBQUM7WUFDL0MsTUFBTSxrQkFBa0IsR0FBRyxJQUFBLDZDQUFjLEVBQUMsU0FBUyxFQUFFLFFBQXdCLENBQUMsQ0FBQztZQUMvRSxJQUFJLENBQUMsSUFBSSxDQUFDLEdBQUcsa0JBQXlCLENBQUM7U0FDMUM7SUFDTCxDQUFDLENBQUMsQ0FBQztJQUNILE9BQU8sSUFBSSxDQUFDO0FBQ2hCLENBQUMsQ0FBQztBQUVGLGtCQUFlLHdCQUF3QixDQUFDIn0=


// WEBPACK FOOTER //
// ../../../../src/utils/dynamicContext/generateComponentContext.ts